<script lang="ts" generics="TValues">
    import type { Field, Form } from '@jmvdevelop/svelte-form';
    import { slide } from 'svelte/transition';
    import * as JobSituation from './ProFilters/JobSituation';
    import MeltMultiSelect from '$components/Form/MeltMultiSelect.svelte';
    import Row from '$components/Form/Row.svelte';
    import * as ProFiltersData from '$components/SearchHeader/ProFilters/ProFiltersData';
    import * as EducationLevel from '$components/SearchHeader/ProFilters/EducationLevel';
    import * as Freelancer from '$components/SearchHeader/ProFilters/Freelancer';
    import * as ExperienceBucket from '$components/SearchHeader/ProFilters/ExperienceBucket';
    import * as ProfileContent from '$components/SearchHeader/ProFilters/ProfileContent';
    import PrettyMultiChoice from '$components/Form/PrettyMultiChoice.svelte';
    import SelectCategory from '$components/Form/SelectCategory/SelectCategory.svelte';
    import StackZIndex from '$components/ZIndex/StackZIndex.svelte';
    import Select from '$components/Form/Select.svelte';
    import * as t from '$trans';
    import { getContainer } from '$components/Context/ContainerContext';

    const { lang } = getContainer();

    export let form: Form<TValues, string>;
    export let proFiltersFields: ProFiltersData.Fields<TValues>;
    export let showFiltersField: Field<TValues, boolean>;

    function resetFilters() {
        form.dispatch(
            form.actions().changeValue(ProFiltersData.empty, proFiltersFields.self),
        );
    }

    $: showFilters = form.stores().fieldValue(showFiltersField);
</script>

<StackZIndex zIndex="current" let:zIndex>
    <div class="container mx-auto mt-[-50px]">
        {#if $showFilters}
            <div
                transition:slide
                class={`z-[--z-index] w-full relative bg-gray-350 rounded-b-[32px]`}
                style={`--z-index: ${zIndex - 1};`}
            >
                <div class="px-[32px] pb-[24px] pt-[50px] flex flex-col gap-[24px]">
                    <div class="flex flex-col gap-[16px]">
                        <div class="grid grid-cols-3 gap-[32px]">
                            <Row
                                {form}
                                field={proFiltersFields.jobSituations}
                                let:field
                                label="Situation professionnelle"
                            >
                                <MeltMultiSelect
                                    {form}
                                    {field}
                                    placeholder="Choisissez une ou plusieurs situations"
                                    options={JobSituation.selectOptions}
                                    valueToOption={JobSituation.valueToOption}
                                />
                            </Row>

                            <Row
                                {form}
                                field={proFiltersFields.category}
                                let:field
                                label="Secteur d'activité"
                            >
                                <SelectCategory
                                    class="svelte-select-sm svelte-select-bg-white"
                                    {form}
                                    {field}
                                    placeholder="Secteur d'activité..."
                                />
                            </Row>
                        </div>

                        <div class="grid grid-cols-3 gap-[32px]">
                            <Row
                                {form}
                                field={proFiltersFields.experienceBuckets}
                                let:field
                                label="Niveau d'expérience"
                            >
                                <MeltMultiSelect
                                    {form}
                                    {field}
                                    placeholder="Choisissez un ou plusieurs niveaux d'expérience"
                                    options={ExperienceBucket.selectOptions}
                                    valueToOption={ExperienceBucket.valueToOption}
                                />
                            </Row>
                            <Row
                                {form}
                                field={proFiltersFields.educationLevels}
                                let:field
                                label="Niveau d'études"
                            >
                                <MeltMultiSelect
                                    {form}
                                    {field}
                                    placeholder="Choisissez un ou plusieurs niveaux d'études"
                                    options={EducationLevel.selectOptions}
                                    valueToOption={EducationLevel.valueToOption}
                                />
                            </Row>
                            <Row
                                {form}
                                field={proFiltersFields.freelancer}
                                let:field
                                label="Freelance"
                            >
                                <Select
                                    class="svelte-select-sm svelte-select-bg-white"
                                    {form}
                                    {field}
                                    required
                                    showChevron
                                    searchable={false}
                                    placeholder=""
                                    options={Freelancer.selectOptions}
                                />
                            </Row>
                        </div>

                        <div class="gap-[32px]">
                            <Row
                                {form}
                                field={proFiltersFields.profileContents}
                                let:field
                                label="Contenu du profil"
                            >
                                <PrettyMultiChoice
                                    class="b:grid-cols-4"
                                    {form}
                                    {field}
                                    choices={ProfileContent.prettyChoices}
                                />
                            </Row>
                        </div>
                    </div>

                    <div class="flex">
                        <button
                            type="button"
                            class="btn-reset flex gap-4 items-center justify-center hover:cursor-pointer hover:opacity-80 text-gray-800 text-14 font-bold"
                            on:click|preventDefault={resetFilters}
                        >
                            <i class="tnp tnp-refresh text-12" aria-hidden={true} />
                            Effacer les filtres
                        </button>
                        <div class="flex-1"></div>
                        <button
                            type="button"
                            class="btn-reset flex gap-4 items-center justify-center hover:cursor-pointer hover:opacity-80 text-gray-800 text-14 font-bold"
                            on:click|preventDefault={() => {
                                form.dispatch(
                                    form.actions().changeValue(false, showFiltersField),
                                );
                            }}
                        >
                            <i class="fa fa-chevron-up text-12" aria-hidden={true} />
                            <span>{t.ui.close({}, $lang)}</span>
                        </button>
                    </div>
                </div>
            </div>
        {/if}
    </div>
</StackZIndex>

<div class="h-[50px]"></div>
